import React from "react";
import Box from "@mui/material/Box";
import EndCustomerCard from "./endcustomerCard/EndCustomerCard";

export function Endcustomer() {
  return (
    <Box>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <EndCustomerCard />
        </Box>
      </Box>
    </Box>
  );
}
